// LICENSE_CODE ZON
'use strict';
/*jslint browser:true, es6:true, node:true, react:true*/

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { img_url } from '../img_url.ts';
import { Link } from '../link.tsx';
import hola_opt from 'hola_opt';
import cn from 'classnames';
import storage from '/util/storage.js';
import { App_context } from '../../context.js';
import './navbar_logo.module.less';
import { Settings_context } from '../../settings_ctx';
const logo_links = {
  '/affiliate_frm': {
    to: '/pricing/premium?ref=affiliate_frm',
    target: '_blank',
    rel: 'noopener noreferrer'
  },
  '/download_ie': {
    to: null
  }
};

const Navbar_logo = props => {
  const _useContext = useContext(Settings_context),
        theme_name = _useContext.theme_name;

  const on_click = props.on_click,
        dark = props.dark,
        to = props.to,
        cls = props.cls,
        logo = props.logo,
        disabled = props.disabled,
        logo_cls = props.logo_cls,
        new_flame = props.new_flame,
        force_type = props.force_type;
  let pro_appid = hola_opt.pro_appid;
  if (!pro_appid) pro_appid = [];

  const _useContext2 = useContext(App_context),
        is_plus = _useContext2.is_plus,
        is_client = _useContext2.is_client;

  const type = force_type !== null && force_type !== void 0 ? force_type : is_plus ? 'premium' : 'basic';
  const color = dark ? '_white' : '';

  const _useLocation = useLocation(),
        pathname = _useLocation.pathname,
        search = _useLocation.search; // XXX: defined in vpn_config
  // why: there is link to open /faq
  // we have to go back to /vpn_config


  const global_homepage = is_client ? storage.get('global_homepage') : '';
  const link_props = global_homepage ? {
    to: global_homepage
  } : logo_links[pathname] || {
    to: to || '/'
  };

  if (link_props && link_props.to == '/vpn_config' || search && search.indexOf('logo_disabled') > -1 || disabled) {
    link_props.to = '';
  }

  const logo_disabled = disabled || !link_props.to;
  const link_cls = cn('navbar_logo', logo && 'custom_logo', logo_cls, logo_disabled ? 'navbar_logo_disabled' : 'navbar_logo_enabled', {
    no_jump: theme_name == 'hola2023'
  });
  const flame_url = new_flame ? 'hola2023/hola_flame.svg' : `hola_flame${theme_name == 'purple' ? '_purple' : ''}.svg`;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('navbar_logo-container', cls)
  }, /*#__PURE__*/React.createElement(Link, _extends({
    className: link_cls
  }, link_props, {
    "aria-label": "Logo",
    onClick: on_click,
    "data-clickid": "navbar_logo"
  }), logo ? /*#__PURE__*/React.createElement("img", {
    src: img_url(logo),
    alt: "logo",
    className: "lazyload"
  }) : /*#__PURE__*/React.createElement(Fragment, null, props.title ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    className: cn('hola-flame', 'lazyload'),
    alt: "Hola Logo",
    src: img_url(flame_url)
  }), /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement("b", null, props.title))) : /*#__PURE__*/React.createElement("img", {
    className: cn(`hola-lettering ${type}`, 'lazyload'),
    alt: "Hola Logo",
    src: img_url(`hola2023/hola_lettering_${type}${color}.svg`)
  }))));
};

export { Navbar_logo };